import React, { useEffect, useState } from "react";
import api from "../../seller-apis/api";
import "./support.css";
import { useLocation } from "react-router-dom";
import { useAlert } from "react-alert";
import SupportMessageModal from "./MessageModal";
import SupportMessageDescriptionModal from "./SupportMessageDescriptionModal";
import { formatedDate } from "../../utilities/ConvertDateFormat";
import { useSelector } from "react-redux";
import PaginationNew from "../common/Pagination";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
var globalFilterData = {
  pageNo: 1,
  size: 12,
  filter: {
  },
  sortFilter: { "adminMsgInfo.latestMsgSentDate": -1 },
};
function CustomerSupport() {
  const alert = useAlert();
  const [showModal, setShowModal] = useState(false);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [ticket, setTicket] = useState(null);
  const [ticketForFilter, setTicketForFilter] = useState([]);
  const [descs, setDescs] = useState([]);
  const [showModalDescription, setShowModalDescription] = useState(false);
  var currentDate = new Date();
  const location = useLocation();
  const { filterStatus } = location.state || {};

  // Get the date before 15 days
  var before15Days = new Date();
  before15Days.setDate(currentDate.getDate() - 30);

  // Format the dates as strings (optional)
  var currentDateStr = currentDate.toISOString().split("T")[0];
  var before15DaysStr = before15Days.toISOString().split("T")[0];
  const [sortdatefrom, setsortdatefrom] = useState(before15DaysStr);
  const [sortdateto, setsortdateto] = useState(currentDateStr);
  const [minValDate, setMinValDate] = useState("2023-08-01");
  const [orderId, setOrderId] = useState("");
  const [totalRcord, setTotalReord] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState("");

  const stateData = useSelector(state => state);
  const statusCheck = ['open', 'reopen', 'repene'];

  // sl-783
  const queryParams = new URLSearchParams(location.search);
  const urlFlag = queryParams.get("flag");
  const [newMessagesFilterStatus, setNewMessagesFilterStatus] = useState(true)
  const [resolvedFilterStatus, setResolvedFilterStatus] = useState(false)
  const [loading, setLoading] = useState(false)
  const [filterBtnClick, setFilterBtnClick] = useState(false)
  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    if (ticket?.adminMsgInfo?.vendorViewed === false) {
      callSupportTicketApi(globalFilterData);
    }
    setShowModal(false);
    setShowRequestModal(false);
  };

  useEffect(() => {
    setLoading(true)
    if (urlFlag === "header") {
      globalFilterData.filter["$and"]= [
          { "adminMsgInfo.vendorViewed": false },
          { "adminMsgInfo.latestMessage": { $exists: true } },
        ];
      setNewMessagesFilterStatus(false)
      queryParams.delete('flag');
      const newUrl = `${location.pathname}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
      window.history.replaceState(null, '', newUrl);
    }
    else {
      // globalFilterData.filter["adminMsgInfo.vendorViewed"] = newMessagesFilterStatus;
    }
    globalFilterData.filter["from-createdAt"] = sortdatefrom + "T00:00:00";
    globalFilterData.filter["to-createdAt"] = sortdateto + "T23:59:59";
    globalFilterData.filter["status.label"] = { "$ne": "Resolved" };
    api.supportTicket.getSupportTicket(globalFilterData).then((ticket) => {
      setTickets(ticket.data);
      setLoading(false)
      setFilterBtnClick(true)
      setTicketForFilter([
        "Functionality Issue",
        "Received Damage Product",
        "Spare part Requirement",
        "Received Wrong Product",
        "Manufacturing Defect",
        "Product Part Missing",
        "Fitting Issue"
      ])
    });
    return () => {
      globalFilterData = {
        pageNo: 1,
        size: 12,
        filter: {},
        sortFilter: { "adminMsgInfo.latestMsgSentDate": -1 },
      };
    }
  }, []);

  const orderFilter = (e) => {
    // console.log(e);
    if (e.keyCode === 13) {
      globalFilterData.pageNo = 1;
      setCurrentPage(1);
      globalFilterData.filter["orderId"] = orderId;
      callSupportTicketApi(globalFilterData);
    }
  };
  const dateFilter = (e) => {
    if (sortdatefrom === undefined || sortdateto === undefined || sortdateto === "" || sortdatefrom === "") {
      alert.show("please select both date");
    }
    else {
      globalFilterData.filter["from-createdAt"] = sortdatefrom + "T00:00:00";
      globalFilterData.filter["to-createdAt"] = sortdateto + "T23:59:59";
      globalFilterData["sortFilter"] = { "createdAt": -1 }
      globalFilterData.pageNo = 1;
      setCurrentPage(1);
      callSupportTicketApi(globalFilterData);
    }
  };
  const applyIssueFilter = (e) => {
    if (e.target.value != "") {
      globalFilterData.filter["issue"] = e.target.value;
    } else {
      globalFilterData.filter["issue"] = "";
    }
    globalFilterData.pageNo = 1;
    setCurrentPage(1);
    callSupportTicketApi();
  };

  function paginate(data) {
    setCurrentPage(data.number);
    globalFilterData.pageNo = data.number;
    callSupportTicketApi();
  }

  const applyFilter = (data) => {
    setStatusFilter(data)
    globalFilterData["sortFilter"] = { "createdAt": -1 }
    if (data != "all") {
      globalFilterData.filter["status.label"] = data;
    } else {
      globalFilterData.filter["status.label"] = "";
    }
    globalFilterData.pageNo = 1;
    setCurrentPage(1);
    callSupportTicketApi(globalFilterData);
  };

  // sl-783

  const styles = {
    filterBtns: {
      active: {
        "background": "rgb(255, 214, 214)",
        "color": "rgb(102, 102, 102)",
        "border": "2px solid rgb(255, 202, 202)",
        "box-shadow": "rgba(0, 0, 0, 0.2) 0px 2px 8px"
      },
      inactive: {
        "background": "white",
        "color": "rgb(102, 102, 102)",
        "border": "2px solid rgb(255, 202, 202)",
        "box-shadow": "rgba(0, 0, 0, 0.1) 0px 2px 5px",
      },
      resolvedActive: {
        "background": "rgb(127, 255, 212)",
        "color": "rgb(102, 102, 102)",
        "box-shadow": "rgba(0, 0, 0, 0.2) 0px 2px 8px",
        "border": "2px solid rgb(214, 255, 214)",
      },
      resolvedInactive: {
        "border": "2px solid rgb(214, 255, 214)",
        "box-shadow": "rgba(0, 0, 0, 0.2) 0px 2px 8px",
        "color": "rgb(102, 102, 102)"
      }
    },
    newMsgBtn: {
      "background": "red",
      "color": "white",
      "fontSize": "11px",
      "padding": "2px 10px",
      "borderRadius": "6px",
      "fontSize": "500",
      "width": "fit-content",
      "margin": "auto"
    },
    newTicketBtn: {
      "background": "darkorange",
      "color": "white",
      "fontSize": "11px",
      "padding": "2px 10px",
      "borderRadius": "6px",
      "fontSize": "500",
      "width": "fit-content",
      "margin": "auto"
    },
    status: {
      "OPEN": {
        "background": "green",
        "color": "white",
        "borderRadius": "20px",
        "padding": "5px 28px",
        "fontSize": "10px"
      },
      "Resolved": {
        "background": "lightgreen",
        "color": "black",
        "borderRadius": "20px",
        "padding": "5px 28px",
        "fontSize": "10px"
      }
    }
  }

  const callSupportTicketApi = async () => {
    try {
      setTickets([])
      setLoading(true)
      const res = await api.supportTicket.getSupportTicket(globalFilterData);
      setTickets(res.data)
      setTotalReord(res.totalRecords);
    }
    catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (filterBtnClick) {
      if (!newMessagesFilterStatus && resolvedFilterStatus) {
        delete globalFilterData.filter["$and"]
        globalFilterData.filter["$or"] = [
          { "adminMsgInfo.vendorViewed": false },
          { "status.label": "Resolved" }
        ];
        delete globalFilterData.filter["adminMsgInfo.vendorViewed"]
        delete globalFilterData.filter["status.label"]
      }
      else if (newMessagesFilterStatus && !resolvedFilterStatus) {
        delete globalFilterData.filter["$or"]
        delete globalFilterData.filter["$and"]
        delete globalFilterData.filter["adminMsgInfo.vendorViewed"]
        globalFilterData.filter["status.label"] = { "$ne": "Resolved" };
      }
      else if (!newMessagesFilterStatus && !resolvedFilterStatus) {
        delete globalFilterData.filter["$or"]
        globalFilterData.filter["$and"] = [
          { "adminMsgInfo.vendorViewed": false },
          { "adminMsgInfo.latestMessage": { $exists: true } },
        ];
        globalFilterData.filter["adminMsgInfo.vendorViewed"] = false
        globalFilterData.filter["status.label"] = { "$ne": "Resolved" };
      }
      else if (newMessagesFilterStatus && resolvedFilterStatus) {
        delete globalFilterData.filter["$and"];
        delete globalFilterData.filter["adminMsgInfo.vendorViewed"]
        delete globalFilterData.filter["status.label"]
        globalFilterData.filter["$or"] = [
          { "adminMsgInfo.vendorViewed": false },
          { "status.label": { "$in": ["Resolved", "OPEN", "Reopen", "Partial", "Auto Closed"] } },
        ]
      }
      globalFilterData.pageNo = 1;
      setCurrentPage(1);
      callSupportTicketApi();
    }
  }, [newMessagesFilterStatus, resolvedFilterStatus])

  const handleNewMsgFilter = () => {
    setNewMessagesFilterStatus(!newMessagesFilterStatus);
  };


  const handleResolvedStatusFilter = () => {
    setResolvedFilterStatus(!resolvedFilterStatus)
  };




  return (
    <>
      <div className="d-flex mb-3 justify-content-start">
        {/* ******** */}
        <div className="theme-shed1 p-2">
          <div className="m-auto mt-1">
            <span className="payment_dates">
              From: -{" "}
              <input
                type="date"
                min={minValDate}
                value={sortdatefrom}
                onChange={(e) => setsortdatefrom(e.target.value)}
              ></input>
            </span>
            <span className="mx-2 payment_dates">
              To: -{" "}
              <input
                type="date"
                min={minValDate}
                value={sortdateto}
                onChange={(e) => setsortdateto(e.target.value)}
              ></input>
            </span>
            <span>
              <button
                className="apply-btn px-3 py-1 ff_Pop fs-14"
                onClick={() => dateFilter()}
              >
                Apply
              </button>
            </span>
            {/* <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => clearFilters()}>Clear</button></span> */}
          </div>
        </div>
        {/* ****** */}
      </div>
      <div className="table-responsive">


        {/* sl-783 */}
        <div className="filter-btns-cs">
          <button onClick={() => {
            handleNewMsgFilter()
          }}
            style={!newMessagesFilterStatus ? styles.filterBtns.active : styles.filterBtns.inactive}
          ><i className="bi bi-chat-left"></i> New Messages</button>
          <button
            onClick={() => {
              handleResolvedStatusFilter()
            }}
            style={resolvedFilterStatus ? styles.filterBtns.resolvedActive : styles.filterBtns.resolvedInactive}
          ><i className="bi bi-funnel"></i> {resolvedFilterStatus ? "Including" : "Excluding"} Resolved</button>
        </div>
        <div className="filter-search-section-cs">
          <h6>Order Details</h6>
          <div className="d-flex cntn-cs">
            <div>
              <input
                type="text"
                className="search-filter-cs ord-id-search-cs"
                value={orderId}
                placeholder="Search with OrderId"
                onChange={(e) => setOrderId(e.target.value)}
                onKeyUp={(e) => orderFilter(e)}
              />
            </div>
            <div>
              <select
                onChange={(e) => applyIssueFilter(e)}
                className="search-filter-cs issue-filter-cs"
              >
                <option value="">Select an issue</option>
                {ticketForFilter && ticketForFilter.map((ticket) => {
                  return <option value={ticket}>{ticket}</option>;
                })}
              </select>
            </div>
          </div>
        </div>
        <table className="table support-table cs-table">
          <tr>
            <th>Reported On</th>
            <th>
              Order Details
            </th>
            <th>
              Issue
            </th>
            <th>Description</th>
            <th>Messages</th>
            <th>
              Status
              <br />
              <select
                onChange={(e) => applyFilter(e.target.value)}
                class="pro_card_comb_box_invent mb-1 form-select form-select-lg"
                style={{ width: "90%" }}
                value={statusFilter}
              >
                <option value="OPEN">Open</option>
                <option value="Reopen">Reopen</option>
                <option value="Resolved">Resolved</option>
                <option value="Partial">Partial Closed</option>
                <option value="Auto Closed">Auto Closed</option>
                <option value="all">All</option>
              </select>
            </th>
          </tr>
          {tickets && tickets.map((ticket) => {
            return (
              <tr className={ticket?.adminMsgInfo?.vendorViewed == false && ticket?.adminMsgInfo?.latestMessage ? "cs-newmsg-row" : ""}>
                <td>{formatedDate(ticket.createdAt)}</td>
                <td>
                  <span className="cs-order-id">{ticket.orderId}</span>

                  <br /> Order Amount : &#8377; {ticket.orders.actualPrice}
                  <br />
                  SKU : {ticket.orders.products[0].productId.SKU}
                </td>
                <td>{ticket.issue}</td>
                <td className="cursor-pointer"
                  onClick={() => {
                    setShowModalDescription(true);
                    setDescs(ticket?.descHistory);
                  }}>
                  <a href="#" className="but">Click here</a>
                </td>
                <td className="cursor-pointer" onClick={() => {
                  handleOpenModal();
                  setTicket(ticket);
                }}>
                  {ticket?.adminMsgInfo?.vendorViewed === false ? <> {ticket?.adminMsgInfo?.latestMessage ? <div style={styles.newMsgBtn}><i className="bi bi-chat-left"></i> New Message</div> : ticket?.status?.label !== "Resolved"? <><div style={styles.newTicketBtn}><i className="bi bi-chat-left"></i> New Ticket</div></>:<></>}
                  </> : <></>}
                  <a href="#" className="but">
                    {
                      !ticket?.adminMsgInfo?.vendorViewed ? "View" : !ticket?.vendorMsgInfo?.vendorViewed ? "Send Message" : "View"
                    }
                  </a>
                </td>
                <td>
                  <span style={styles.status[ticket.status?.label]}>{ticket.status?.label}</span>
                  {ticket?.status?.label === "Resolved" ? <OverlayTrigger
                    key="tds"
                    placement="bottom"
                    overlay={
                      <Tooltip id={`tooltip-tds`} className="fs-16 order_page_tooltip">
                        <p className='fs-10 f-500 payment_page_tooltip_1'> <strong>Resolved On:</strong> {formatedDate(ticket?.statusHistory?.[0]?.createdAt || ticket?.updatedAt)}
                          <br /><strong>Status Type:</strong> {ticket?.statusType || ticket?.subStatus?.label}
                        </p>
                      </Tooltip>
                    }
                  >
                    <i className="bi bi-info-circle" style={{background:"transparent"}}></i>
                  </OverlayTrigger> : <></>}</td>
              </tr>
            );
          })}
          {loading ? <tr>
            <td colspan="6" className="text-center">
              Loading...
            </td>
          </tr> : tickets && tickets.length === 0 ? (
            <tr>
              <td colspan="6" className="text-center">
                No data found
              </td>
            </tr>
          ) : (
            ""
          )}
        </table>
      </div>
      <PaginationNew
        number={totalRcord}
        paginate={paginate}
        activ={currentPage}
        comp={"support"}
      />


      {ticket != null ? (
        <>
          <SupportMessageModal
            show={showModal}
            handleClose={handleCloseModal}
            ticket={ticket}
          />

        </>
      ) : (
        ""
      )}
      <SupportMessageDescriptionModal
        showModalDescription={showModalDescription}
        handleCloseDesc={() => setShowModalDescription(false)}
        descs={descs}
      />
    </>
  );
}

export default CustomerSupport;
